import { render, staticRenderFns } from "./HideMinor.vue?vue&type=template&id=66884aa0&"
import script from "./HideMinor.vue?vue&type=script&lang=ts&"
export * from "./HideMinor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports